export default "__VITE_ASSET__RtPaSsLf__"